<template>
  <common-dialog
    ref="dialog"
    :title="mode + ' Stack'"
    :inputs-map="stackInputs"
    :input-value-change="valueChange"
    :save-cb="saveStack"
    :reset-inputs="resetInputs"
  />
</template>
<script>
import cloneDeep from 'lodash/cloneDeep'
import get from 'lodash/get'
import { dialogMixin } from '@/core/mixin/dialog'
// components
import CommonDialog from '@/components/common/CommonDialog.vue'
// api
import { StackForm } from '@/core/models/stack'
import { createStack, editStack } from '@/api/stack'
import PagesMessage from '@/core/message/pages'
export default {
  name: 'StackEdit',
  mixins: [dialogMixin],
  components: {
    CommonDialog
  },
  data() {
    return {
      stackInputs: cloneDeep(Object.values(StackForm)),
      originStack: null
    }
  },
  computed: {
    mode() {
      return this.originStack ? 'Edit' : 'Create'
    }
  },
  methods: {
    open(origin) {
      this.$refs.dialog.open()
      this.originStack = origin
      this.resetInputs()
    },
    close() {
      this.$refs.dialog.close()
    },
    saveStack(inputsArray) {
      const inputMap = Object.fromEntries(
        inputsArray.map(one => [one.key, one.value])
      )
      if (this.originStack) {
        inputMap.id = this.originStack.id
      }
      const func = this.originStack ? editStack : createStack
      func(inputMap).then(res => {
        if (res) {
          PagesMessage.emit(PagesMessage.eventMap.REFRESH_STACK_LIST)
        } else {
          this.$message.error(`Failed to ${this.mode} stack!`)
        }
      })
      return [true, '']
    },
    resetInputs() {
      this.stackInputs.forEach(one => {
        one.value = get(this.originStack, one.key, one.default)
      })
    },
    valueChange() {}
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';
</style>
